import { datadogRum } from '@datadog/browser-rum';

export function reportError(error: unknown, context?: Record<string, unknown>) {
  datadogRum.addError(error, context);
}
